<template>
    <div class="content">
        <div class="search_wrapper">
            <div class="search_head">
                <span>查询条件</span>
                <i class="searchDomw" @click="isSearchContent = !isSearchContent" :class="isSearchContent == true ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"></i>
                <!-- <el-button
                    style="float: right; padding: 3px 0; color: #000"
                    type="text"
                    @click="clearData"
                >
                    <i class="el-icon-refresh"></i>
                    刷新页面
                </el-button> -->
            </div>
            <div class="search_content" v-show="isSearchContent">
                <div class="search_inline">
                    <el-form label-width="90px">
                        <el-row>
                            <el-col :span="5">
                                <el-form-item label="时间">
                                    <el-select
                                        style="width: 100%"
                                        v-model="years"
                                        clearable
                                        placeholder="时间"
                                    >
                                        <el-option
                                            v-for="item in yearList"
                                            :key="item"
                                            :label="item"
                                            :value="item"
                                        >
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>

                            <el-col :span="5" :offset="1">
                                <el-form-item label="周期">
                                    <el-select
                                        style="width: 100%"
                                        v-model="cycle"
                                        clearable
                                        placeholder="周期"
                                    >
                                        <el-option
                                            v-for="item in cycleList"
                                            :key="item.value"
                                            :label="item.label"
                                            :value="item.value"
                                        >
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :span="5" :offset="2">
                                <el-button
                                    type="primary"
                                    icon="el-icon-search"
                                    @click="searchData"
                                    class="searchBtns"
                                    >搜索</el-button
                                >
                                <el-button
                                    type="info"
                                    icon="el-icon-delete"
                                    @click="clearData"
                                    >清除条件</el-button
                                >
                            </el-col>
                        </el-row>
                    </el-form>
                </div>
                <!-- <div class="arrowDown">
                    <i
                        :class="
                            isSearchContent === true
                                ? 'el-icon-arrow-up'
                                : 'el-icon-arrow-down'
                        "
                        style="color: #000"
                        @click="isSearchContent = !isSearchContent"
                    ></i>
                </div> -->
            </div>
        </div>
        <div class="table_title">
            <div class="btn_group">
                <el-button-group>
                    <el-button
                        type="success"
                        icon="iconfont icon-xinzeng"
                        class="openBtns"
                        @click="handleTableForm('新增', 'add')"
                        >新增</el-button
                    >
                </el-button-group>
            </div>
            <!-- 筛选按钮 -->
            <div class="screen_container">
                <el-button-group>
                    <el-button
                        type="primary"
                        icon="el-icon-refresh"
                        class="dropRests"
                        @click="clearData"
                    ></el-button>
                    <!-- <el-button type="primary" style="padding: 10px 20px"> -->
                        <el-dropdown trigger="click" :hide-on-click="false" class="dropdown1">
                            <span class="el-dropdown-link">
                                <i
                                    class="el-icon-s-grid el-icon--right"
                                    style="color: #fff"
                                ></i>
                                <i
                                    class="el-icon-arrow-down el-icon--right"
                                ></i>
                            </span>
                            <el-dropdown-menu
                                slot="dropdown"
                                class="table_checkbox"
                            >
                                <el-dropdown-item>
                                    <el-checkbox-group
                                        v-model="tableChekbox"
                                        @change="tableChekboxChange"
                                    >
                                        <el-checkbox label="序号"></el-checkbox
                                        ><br />
                                        <el-checkbox
                                            label="组织类型"
                                        ></el-checkbox
                                        ><br />
                                        <el-checkbox
                                            label="计划类型"
                                        ></el-checkbox
                                        ><br />
                                        <el-checkbox label="时间"></el-checkbox
                                        ><br />
                                        <el-checkbox label="周期"></el-checkbox
                                        ><br />
                                        <el-checkbox label="频次"></el-checkbox
                                        ><br />
                                        <el-checkbox label="操作"></el-checkbox
                                        ><br />
                                    </el-checkbox-group>
                                </el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                    <!-- </el-button> -->
                </el-button-group>
            </div>
        </div>
        <!-- tableb表格 -->
        <div class="table_container">
            <el-table
                :data="tableData"
                tooltip-effect="dark"
                style="width: 100%"
                height="550px"
                :header-cell-style="{ background: '#e6e6e6', color: '#000' }"
                border
            >
                <el-table-column
                    type="index"
                    width="70"
                    label="序号"
                    align="center"
                    v-if="
                        this.tempTableChekbox.findIndex(
                            (item) => item == '序号'
                        ) != -1
                    "
                    :show-overflow-tooltip="true"
                >
                </el-table-column>
                <el-table-column
                    label="组织类型"
                    align="center"
                    v-if="
                        this.tempTableChekbox.findIndex(
                            (item) => item == '组织类型'
                        ) != -1
                    "
                    :show-overflow-tooltip="true"
                >
                    <template slot-scope="scope">
                        <span v-if="scope.row.orgType == 0">组织工作</span>
                    </template>
                </el-table-column>

                <el-table-column
                    label="计划类型"
                    align="center"
                    prop="planTypeName"
                    v-if="
                        this.tempTableChekbox.findIndex(
                            (item) => item == '计划类型'
                        ) != -1
                    "
                    :show-overflow-tooltip="true"
                >
                </el-table-column>
                <el-table-column
                    label="时间"
                    align="center"
                    prop="years"
                    v-if="
                        this.tempTableChekbox.findIndex(
                            (item) => item == '时间'
                        ) != -1
                    "
                    :show-overflow-tooltip="true"
                >
                </el-table-column>
                <el-table-column
                    label="周期"
                    align="center"
                    v-if="
                        this.tempTableChekbox.findIndex(
                            (item) => item == '周期'
                        ) != -1
                    "
                    :show-overflow-tooltip="true"
                >
                    <template slot-scope="scope">
                        <span v-if="scope.row.cycle == 1">年度</span>
                        <span v-if="scope.row.cycle == 2">季度</span>
                        <span v-if="scope.row.cycle == 3">月度</span>
                    </template>
                </el-table-column>
                <el-table-column
                    label="频次"
                    align="center"
                    prop="frequency"
                    v-if="
                        this.tempTableChekbox.findIndex(
                            (item) => item == '频次'
                        ) != -1
                    "
                    :show-overflow-tooltip="true"
                >
                </el-table-column>

                <el-table-column
                    label="操作"
                    align="center"
                    width="200px"
                    fixed="right"
                    v-if="
                        this.tempTableChekbox.findIndex(
                            (item) => item == '操作'
                        ) != -1
                    "
                >
                    <template slot-scope="scope">
                        <span
                            @click="handleTableForm('查看', scope.row)"
                            style="margin-right: 12px; cursor: pointer"
                            >查看</span
                        >
                        <span
                            @click="handleTableForm('编辑', scope.row)"
                            style="margin-right: 12px; cursor: pointer"
                            >编辑</span
                        >
                        <span
                            @click="deleteItem(scope.row)"
                            style="margin-right: 12px; cursor: pointer"
                            >删除</span
                        >
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="pagination_container">
            <el-pagination
                :page-size="pageOne.pageSize"
                :current-page.sync="pageOne.pageNo"
                layout="total, sizes, prev, pager, next, jumper"
                :total="pageOne.total"
                @size-change="handletableDataSize"
                @current-change="handleTableDataChange"
            ></el-pagination>
        </div>
        <open-form
            v-if="formVisible"
            :openData="formInfo"
            @cancleOpen="cancleOpen"
        ></open-form>
    </div>
</template>
<script>
import openForm from "./components/openForm"
export default {
    props: ["personData"],
    components: { openForm },
    data() {
        return {
            yearList: ["2019", "2020", "2021"],
            cycleList: [
                { label: "年度", value: 1 },
                { label: "季度", value: 2 },
                { label: "月度", value: 3 },
            ],
            formVisible: false,
            formInfo: {},
            years: "",
            cycle: "",
            personIdCard: "",
            isSearchContent: false,
            pageOne: { pageSize: 10, pageNo: 1, total: 0 },
            tableData: [],
            radioId: "",
            tempTableChekbox: [
                "序号",
                "组织类型",
                "计划类型",
                "时间",
                "周期",
                "频次",
                "操作",
            ],
            tableChekbox: [
                "序号",
                "组织类型",
                "计划类型",
                "时间",
                "周期",
                "频次",
                "操作",
            ],
        }
    },
    created() {
        this.getList()
    },
    watch: {
        personData(old, news) {
            // console.log(old, news, this.personData, "组织id");
            this.getList()
        },
    },
    methods: {
        // 搜索
        searchData() {
            this.getList()
        },

        //删除表格信息
        deleteItem(date) {
            let params = {
                communityId: this.personData,
                id: date.id,
            }
            this.$confirm("确认永久删除吗?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            }).then(() => {
                this.$http
                    .request({
                        url: "/ypt/admin/activityPlan/info/deleteById",
                        method: "POST",
                        data: params,
                    })
                    .then((res) => {
                        if (res.code === 200) {
                            this.$message.success("删除成功")
                            // this.tableData = [];
                            this.getList()
                        }
                    })
            })
        },
        // 当前页
        handleTableDataChange(val) {
            this.pageOne.pageNo = val
            this.getList()
        },
        // 分页大小
        handletableDataSize(val) {
            this.pageOne.pageSize = val
            this.getList()
        },
        // 选择列的展示方式
        tableChekboxChange(val) {
            this.tempTableChekbox = val.map((item) => item)
        },
        //重置
        clearData() {
            this.years = ""
            this.cycle = ""
            this.pageOne.pageSize = 10
            this.pageOne.pageNo = 1
            this.getList()
        },
        // 获取数据
        getList() {
            let params = {
                pageNo: this.pageOne.pageNo,
                pageSize: this.pageOne.pageSize,
                communityId: this.personData,
                years: this.years,
                cycle: this.cycle,
            }
            this.$http
                .request({
                    url: "/ypt/admin/activityPlan/info/findList",
                    method: "POST",
                    data: params,
                })
                .then((res) => {
                    if (res.code == 200) {
                        if (res.content == null || res.content == "null") {
                            this.tableData = []
                            this.pageOne.total = 0
                            return
                        }
                        if (res.content.list.length > 0) {
                            res.content.list.forEach((item) => {
                                let planTypeName = ""
                                let planType = item.planType.split(",")
                                if (planType.length < 2) {
                                    planType.forEach((it) => {
                                        if (it == "0") {
                                            planTypeName = "社区活动"
                                        }
                                    })
                                } else {
                                    planType.forEach((it) => {
                                        if (it == "0") {
                                            planTypeName += "社区活动、"
                                        }
                                    })
                                }
                                item.planTypeName = planTypeName
                            })
                        }

                        this.tableData = res.content.list
                        this.pageOne.total = res.content.count
                    }
                })
        },
        // 操作方法
        handleTableForm(title, row) {
            this.formVisible = true
            this.formInfo = {
                title: title,
                id: row != "add" ? row.id : "",
                state: true,
                socialOrgId: this.personData,
            }
        },
        cancleOpen(data) {
            this.formVisible = false
            this.formInfo = {}
            if (data == true) {
                this.getList()
            }
        },
    },
}
</script>
<style lang="less" scoped>
/deep/.btn_group {
    margin-top: 0px !important;
}
/deep/.table_title {
    margin-top: 10px !important;
}

/deep/ .search_wrapper {
  display: flex;
  flex-direction: column;
  position: relative;
  background: #F1F2F6;
  box-shadow:  0 0 6px rgba(100, 100, 100, 0.16);
  overflow: hidden;
  border-radius: 4px;
  .search_head {
    background: #fff;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    font-size: 14px;
    color: rgb(0, 0, 0);
    border-color: rgb(217, 217, 217);
    padding: 6px 15px;
    border-top-left-radius: 3px;
    border-top-right-radius: 3px;
  }
  .search_content {
    padding: 15px 20px 0px 5px;
    border: 1px solid rgb(217, 217, 217);
    // display: flex;
    flex-direction: row;
    flex-wrap: wrap;
  }
  .search_inline {
    width: 100%;
  }
  .arrowDown {
    width: 28px;
    height: 28px;
    background: #edf2f0;
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    left: 50%;
    bottom: -14px;
    transform: translate(-50%, 0px);
    border-radius: 50%;
    z-index: 2;
    cursor: pointer;
  }
}
.searchDomw{cursor: pointer;}
</style>